export default __webpack_public_path__ + "static/media/icons8-plumbing.f1546bc0.svg";